import React from 'react';
import Modal, { ModalRef } from '../ui/Modal';
import { Button } from '../ui/Button';
import { useTranslations } from 'next-intl';

export interface UnsavedWarningModalProps {
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  onDiscard?: () => void;
  onSave?: () => void;
  showClose?: boolean;
  closeOnClickOutside?: boolean;
}

export type UnsavedWarningModalRef = ModalRef;

const UnsavedWarningModal = React.forwardRef<UnsavedWarningModalRef, UnsavedWarningModalProps>(
  (
    { isOpen, onOpenChange, onDiscard, onSave, showClose = true, closeOnClickOutside = false },
    ref
  ) => {
    const t = useTranslations('common');
    const handleDiscard = () => {
      onDiscard?.();
      onOpenChange?.(false);
    };

    const footer = (
      <div className="flex justify-end gap-3">
        <Button variant="outline" onClick={handleDiscard}>
          {t('unsavedChangesDiscard')}
        </Button>
        <Button variant="default" onClick={onSave}>
          {t('unsavedChangesSave')}
        </Button>
      </div>
    );

    return (
      <Modal
        ref={ref}
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        title={t('unsavedChanges')}
        showClose={showClose}
        closeOnClickOutside={closeOnClickOutside}
        footer={footer}
        bodyClassName="!max-w-md"
      >
        <div className="px-4 py-2">
          <p className="text-sm text-muted-foreground">{t('unsavedChangesDescription')}</p>
        </div>
      </Modal>
    );
  }
);

UnsavedWarningModal.displayName = 'UnsavedWarningModal';

export default UnsavedWarningModal;
